export default {
  middleware_url: "https://wip.exliv.fluid-it.fr",
  cake_url: "https://wip.cake.exliv.fluid-it.fr",
  isWavesoftEnabled: false,
  isUrbantzEnabled: false,
  billingConforamaEnabled: false,
};
